<template>
  <div>
    <div v-if="loading" class="text-center p-5">Loading slide promotion...</div>

    <div v-else>
      <div v-if="slides.length === 0" class="text-center text-muted p-4 border rounded">
        No slide promotion available.
      </div>

      <table v-else class="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>URL</th>
            <th class="text-right">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in slides" :key="item.id">
            <!-- Image -->
            <td>
              <div v-if="item.urlImage">
                <a :href="item.urlImage" target="_blank" title="View Image">
                  <img
                    :src="item.urlImage"
                    alt="Thumbnail"
                    style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;"
                  />
                </a>
              </div>
              <div v-else class="text-muted small">No image</div>
            </td>

            <!-- URL -->
            <td>
              <a :href="item.Url" target="_blank">{{ item.Url | truncate(50) }}</a>
            </td>

           

            <!-- Actions -->
            <td>
              <div class="d-flex justify-content-end align-items-center gap-2">
                <img
                  src="../../assets/img/edit-btn.png"
                  width="30px"
                  class="cursor-pointer"
                  @click="openEditPoster(item)"
                />
                <img
                  src="../../assets/img/delete-btn.png"
                  width="30px"
                  class="cursor-pointer"
                  @click="deletePoster(item.id)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Poster Edit / Upload Popup -->
    <div v-if="openPoster" class="upload-popup-overlay" @click.self="closePoster">
      <div class="upload-popup-card">
        <button class="close-btn" @click="closePoster">×</button>
        <h4 class="popup-title text-left">Upload / Edit Poster</h4>

        <!-- URL -->
        <div class="text-left mt-4">
          <label>Url</label>
          <CInput v-model="urlPoster" type="text" placeholder="Enter title..." />
        </div>

        <!-- Image Upload -->
        <div
          class="upload-dropzone"
          @click="triggerFileInputPoster"
          @dragover.prevent
          @drop.prevent="handleDrop"
        >
          <input
            type="file"
            ref="fileInputPoster"
            @change="handleFilesPoster"
            accept=".png,.jpg,.jpeg"
            style="display:none"
          />

          <div v-if="previewUrlPoster" class="image-preview">
            <img :src="previewUrlPoster" alt="Preview" class="preview-img" />
          </div>

          <div v-else class="upload-content">
            <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
            <p class="upload-text">Browse File</p>
            <p class="upload-subtitle">Choose a file or drag & drop it here</p>
            <p class="upload-format-text">PNG, JPG, or JPEG formats, up to 10 MB</p>
          </div>
        </div>

        <!-- File Preview -->
        <div v-if="uploadedFilePoster" class="file-preview">
          <span class="file-name">
            <i class="fa fa-paperclip"></i> {{ uploadedFilePoster.name }}
          </span>
          <button class="remove-file" @click="removeFilePoster">×</button>
        </div>

        <!-- Submit -->
        <button class="upload-submit-btn" :disabled="isUploading" @click="submitPoster">
          {{ isUploading ? "Uploading..." : "Save" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SlidePromotionList",
  data() {
    return {
      slides: [],
      loading: false,
      openPoster: false,
      selectedPosterId: null,
      urlPoster: "",
      uploadedFilePoster: null,
      uploadedFileUrl: "",
      uploadedFileId: null,
      previewUrlPoster: "",
      isUploading: false,
    };
  },
  filters: {
    truncate(value, limit) {
      if (!value) return "";
      return value.length > limit ? value.substring(0, limit) + "..." : value;
    },
  },
  methods: {
    async loadSlide() {
      this.loading = true;
      try {
        const res = await this.$API.get(this.$GetListPoster);
        if (res.status === 200 && res.data) {
          // Ensure array
          const slidesData = Array.isArray(res.data) ? res.data : [res.data];

          this.slides = slidesData.map((item) => {
            if (item.urlImage?.startsWith("URL: ")) {
              item.urlImage = item.urlImage.replace(/^URL:\s*/, "");
            }
            return item;
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    // Toggle status
    async toggleStatus(item) {
      item.isUpdatingStatus = true;
      try {
        const payload = {
          id: item.id,
          Status: !item.Status,
        };
        await this.$API.post(this.$InsertPoster, payload, { withCredentials: true });
        item.Status = !item.Status;
      } catch (err) {
        console.error(err);
      } finally {
        item.isUpdatingStatus = false;
      }
    },

    // Open Edit Poster
    openEditPoster(item) {
      this.selectedPosterId = item.id;
      this.urlPoster = item.Url;
      this.previewUrlPoster = item.urlImage;
      this.uploadedFileUrl = item.urlImage;
      this.openPoster = true;
    },

    closePoster() {
      this.openPoster = false;
      this.selectedPosterId = null;
      this.urlPoster = "";
      this.uploadedFilePoster = null;
      this.previewUrlPoster = "";
      this.uploadedFileUrl = "";
      this.uploadedFileId = null;
    },

    triggerFileInputPoster() {
      this.$refs.fileInputPoster.click();
    },

    handleFilesPoster(e) {
      const file = e.target.files[0];
      if (file) {
        this.uploadedFilePoster = file;
        this.previewUrlPoster = URL.createObjectURL(file);
      }
    },

    removeFilePoster() {
      this.uploadedFilePoster = null;
      this.previewUrlPoster = "";
      this.uploadedFileUrl = "";
      this.uploadedFileId = null;
    },

    // Submit Poster (Upload + Save)
    async submitPoster() {
      this.isUploading = true;
      try {
        // Upload file if selected
        if (this.uploadedFilePoster) {
          const formData = new FormData();
          formData.append("file", this.uploadedFilePoster);

          const res = await this.$API.post(this.$UploadFilePoster, formData, {
            withCredentials: true,
            timeout: 600000,
          });

          const uploaded = Array.isArray(res.data) ? res.data[0] : res.data;

          if (uploaded.success) {
            this.uploadedFileId = uploaded.fileId;
            this.uploadedFileUrl = uploaded.fileUrl.replace(/^URL:\s*/, "");
          } else {
            alert("❌ Upload failed: " + (uploaded.error || "Unknown error"));
            return;
          }
        }

        // Save / Update poster
        const payload = {
          id: this.selectedPosterId,
          url: this.urlPoster,
          urlToImage: this.uploadedFileUrl || "",
          fileAwsId: this.uploadedFileId || null,
        };

        await this.$API.post(this.$InsertPoster, payload, { withCredentials: true });
        alert("✅ Slide promotion saved successfully!");
        this.closePoster();
        this.loadSlide();
      } catch (err) {
        console.error(err);
        alert("⚠️ Failed to save slide promotion.");
      } finally {
        this.isUploading = false;
      }
    },

    // Delete Poster
    async deletePoster(id) {
  if (!confirm("Are you sure you want to delete this slide?")) return;

  try {
    const formData = new FormData();
    formData.append("id", id);

    await this.$API.post(this.$DeletePoster, formData, {
      withCredentials: true,
    });

    alert("✅ Slide deleted successfully!");
    this.loadSlide();
  } catch (err) {
    console.error(err);
    alert("⚠️ Failed to delete slide.");
  }
},
  },

  async mounted() {
    this.loadSlide();
  },
};
</script>

<style scoped>
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
}
.cursor-pointer {
  cursor: pointer;
}
.upload-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.upload-popup-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: 400px;
  max-height: 90vh;
  overflow-y: auto;
}
.preview-img {
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
}
</style>